import React from 'react'

const ModalFooter = (props) => {
    return (
        <div className="flex items-center justify-end gap-2 px-6 py-3 border-t border-gray-100 rounded-b">
            {props.children}
        </div>
    )
}

export default ModalFooter